import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { 
  MdRocketLaunch, 
  MdAutoFixHigh, 
  MdTrendingUp, 
  MdGroup, 
  MdFeedback, 
  MdPublic 
} from 'react-icons/md';
import '../assets/styles/ServiceDetailsService.css';

const ServiceDetailsServices = () => {
  const services = [
    {
      icon: <MdRocketLaunch size={48} />,
      title: "Launching a New Product",
      description: "Ensuring a product is visually appealing, user-centric, and intuitive is crucial for a successful launch. Our team excels in crafting UI/UX designs that captivate users and establish a strong market presence right from the beginning."
    },
    {
      icon: <MdAutoFixHigh size={48} />,
      title: "Redesigning Existing Applications",
      description: "Revitalizing user experience through strategic redesign can make existing applications more efficient and aligned with current trends. We specialize in updating UI/UX to meet today's user expectations, injecting new life into your applications."
    },
    {
      icon: <MdTrendingUp size={48} />,
      title: "Low Conversion Rates Due to Poor Usability",
      description: "Improving usability through enhanced UI/UX design is key to increasing user engagement and conversion rates. We focus on making applications more navigable and user-friendly, leading to a seamless experience that encourages user action."
    },
    {
      icon: <MdGroup size={48} />,
      title: "Improving User Retention",
      description: "A strategic UI/UX redesign can significantly boost user retention. Our approach creates engaging, satisfying, and easy-to-use interfaces that encourage long-term user engagement and loyalty."
    },
    {
      icon: <MdFeedback size={48} />,
      title: "Responding to User Feedback",
      description: "Incorporating user feedback is essential for a responsive and user-centric product development. We integrate this feedback into UI/UX design, ensuring your product continually evolves to meet user needs."
    },
    {
      icon: <MdPublic size={48} />,
      title: "Expanding to New Markets",
      description: "Adapting UI/UX design for new market demographics is crucial for successful expansion. Our team is skilled in customizing designs to appeal to diverse audiences, ensuring your product resonates well in different cultural contexts."
    }
  ];

  return (
    <Container fluid className="design-services-container py-5">
      <Container>
        <Row className="mb-5 text-center">
          <Col>
            <h3 className="display-5 main-title">Anytime Is the Right Time for Exceptional UI/UX Design. Start Today!</h3>
          </Col>
        </Row>
        
        <Row xs={1} md={2} lg={3} className="g-4">
          {services.map((service, index) => (
            <Col key={index}>
              <Card className="h-100 service-card">
                <Card.Body className="text-center p-4">
                  <div className="icon-wrapper mb-3">
                    {service.icon}
                  </div>
                  <Card.Title className="service-title">{service.title}</Card.Title>
                  <Card.Text className="service-description">
                    {service.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
};

export default ServiceDetailsServices;